// store.ts
import { config } from '@/config';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session'; // Lưu vào sessionStorage
import { apiCaller } from './query';
import bannerSlice from './slice/banner.slice';
import checkoutVerificationSlice from './slice/checkoutVerification.slice';
import contextualBarSlice from './slice/contextualBar.slice';
import dashboardSlice from './slice/Dashboard/dashboard.slice';
import previewSlice from './slice/preview.slice';
import pricingSlice from './slice/pricing.slice';
import sessionSlice from './slice/session.slice';
import shopSlice from './slice/shop.slice';
import termAndConditionSlice from './slice/termAndCondition.slice';
import toastSlice from './slice/Toast/toast.slice';
import translationSlice from './slice/translation.slice';
import { cmsApiCaller } from '@/redux/query/cms-admin';

const termAndConditionPersistConfig = {
  key: `${config.shop}-termAndCondition`,
  storage: storageSession,
  whitelist: ['termAndConditionType'], // Chỉ lưu trạng thái termAndConditionType
};

const bannerPersistConfig = {
  key: `${config.shop}-banner`,
  storage: storageSession,
};

const sessionPersistConfig = {
  key: `${config.shop}-session`,
  storage: storageSession,
};

const rootReducer = combineReducers({
  toast: toastSlice.reducer,
  preview: previewSlice.reducer,
  translation: translationSlice.reducer,
  dashboard: dashboardSlice.reducer,
  banner: persistReducer(bannerPersistConfig, bannerSlice.reducer),
  apiCaller: apiCaller.reducer,
  cmsApiCaller: cmsApiCaller.reducer,
  contextualBar: contextualBarSlice.reducer,
  checkoutVerification: checkoutVerificationSlice.reducer,
  termAndCondition: persistReducer(termAndConditionPersistConfig, termAndConditionSlice.reducer), // Áp dụng persist cho termAndConditionSlice
  sessionStorage: persistReducer(sessionPersistConfig, sessionSlice.reducer),
  shop: shopSlice.reducer,
  pricing: pricingSlice.reducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(apiCaller.middleware, cmsApiCaller.middleware);
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const persistor = persistStore(store);
export default store;
